// BASICS
export const BOOL_VALUE_YES = 'Ja'
export const BOOL_LABEL_YES = 'Ja'
export const BOOL_VALUE_NO = 'Nein'
export const BOOL_LABEL_NO = 'Nein'

// COUNTRY
export const COUNTRY_VALUE_GERMANY = 'Deutschland'
export const COUNTRY_LABEL_GERMANY = 'Ja'
export const COUNTRY_VALUE_OTHER = 'anderes Land'
export const COUNTRY_LABEL_OTHER = 'Nein'

export const COUNTRY_OPTIONS = [
  { value: COUNTRY_VALUE_GERMANY, label: COUNTRY_LABEL_GERMANY },
  { value: COUNTRY_VALUE_OTHER, label: COUNTRY_LABEL_OTHER }
]

// YEARS_SINCE_FIRST_TURNOVER
export const FIRST_TURNOVER_VALUE_FIVE_OR_MORE = 'Aufnahme vor mindestens 5 Jahren'
export const FIRST_TURNOVER_LABEL_FIVE_OR_MORE = 'Vor mehr als 5 Jahren'
export const FIRST_TURNOVER_VALUE_THREE_TO_FIVE = 'Aufnahme vor 3 bis 5 Jahren'
export const FIRST_TURNOVER_LABEL_THREE_TO_FIVE = 'Vor 3 bis 5 Jahren'
export const FIRST_TURNOVER_VALUE_2019_OR_EARLIER = 'Vor Januar 2019'
export const FIRST_TURNOVER_LABEL_2019_OR_EARLIER = 'Vor Januar 2019'
export const FIRST_TURNOVER_VALUE_2019_OR_LATER = 'Nach Januar 2019'
export const FIRST_TURNOVER_LABEL_2019_OR_LATER = 'Nach Januar 2019'

export const FIRST_TURNOVER_OPTIONS = [
  { value: FIRST_TURNOVER_VALUE_FIVE_OR_MORE, label: FIRST_TURNOVER_LABEL_FIVE_OR_MORE },
  { value: FIRST_TURNOVER_VALUE_THREE_TO_FIVE, label: FIRST_TURNOVER_LABEL_THREE_TO_FIVE },
  { value: FIRST_TURNOVER_VALUE_2019_OR_EARLIER, label: FIRST_TURNOVER_LABEL_2019_OR_EARLIER },
  { value: FIRST_TURNOVER_VALUE_2019_OR_LATER, label: FIRST_TURNOVER_LABEL_2019_OR_LATER }
]

// MANAGING_DIRECTORS_SALARIES

export const MANAGING_DIRECTORS_SALARIES_VALUE_LESS_THAN_150 = 'Unter 150.000 EUR p.a.'
export const MANAGING_DIRECTORS_SALARIES_LABEL_LESS_THAN_150 = 'Unter 150.000 EUR p.a.'
export const MANAGING_DIRECTORS_SALARIES_VALUE_MORE_THAN_150 = 'über 150.000 EUR p.a.'
export const MANAGING_DIRECTORS_SALARIES_LABEL_MORE_THAN_150 = 'über 150.000 EUR p.a.'
export const MANAGING_DIRECTORS_SALARIES_VALUE_NONE = 'nichtzutreffend, da keine Kapitalgesellschaft (GmbH, AG, UG)'
export const MANAGING_DIRECTORS_SALARIES_LABEL_NONE = 'nichtzutreffend, da keine Kapitalgesellschaft (GmbH, AG, UG)'

export const MANAGING_DIRECTORS_SALARIES_OPTIONS = [
  { value: MANAGING_DIRECTORS_SALARIES_VALUE_LESS_THAN_150, label: MANAGING_DIRECTORS_SALARIES_LABEL_LESS_THAN_150 },
  { value: MANAGING_DIRECTORS_SALARIES_VALUE_MORE_THAN_150, label: MANAGING_DIRECTORS_SALARIES_LABEL_MORE_THAN_150 },
  { value: MANAGING_DIRECTORS_SALARIES_VALUE_NONE, label: MANAGING_DIRECTORS_SALARIES_LABEL_NONE },
]

// NUMBER_OF_EMPLOYEES
export const NUMBER_OF_EMPLOYEES_VALUE_10_OR_LESS = 'weniger als 10 Mitarbeiter oder solo-selbstständig'
export const NUMBER_OF_EMPLOYEES_LABEL_10_OR_LESS = 'weniger als 10 Mitarbeiter oder solo-selbstständig'
export const NUMBER_OF_EMPLOYEES_VALUE_10_TO_50 = '10,1 bis einschließlich 50'
export const NUMBER_OF_EMPLOYEES_LABEL_10_TO_50 = '10,1 bis einschließlich 50'
export const NUMBER_OF_EMPLOYEES_VALUE_50_TO_249 = '50,1-249'
export const NUMBER_OF_EMPLOYEES_LABEL_50_TO_249 = '50,1-249'
export const NUMBER_OF_EMPLOYEES_VALUE_250_OR_MORE = '250 oder mehr'
export const NUMBER_OF_EMPLOYEES_LABEL_250_OR_MORE = '250 oder mehr'

export const NUMBER_OF_EMPLOYEES_OPTIONS = [
  { value: NUMBER_OF_EMPLOYEES_VALUE_10_OR_LESS, label: NUMBER_OF_EMPLOYEES_LABEL_10_OR_LESS },
  { value: NUMBER_OF_EMPLOYEES_VALUE_10_TO_50, label: NUMBER_OF_EMPLOYEES_LABEL_10_TO_50 },
  { value: NUMBER_OF_EMPLOYEES_VALUE_50_TO_249, label: NUMBER_OF_EMPLOYEES_LABEL_50_TO_249 },
  { value: NUMBER_OF_EMPLOYEES_VALUE_250_OR_MORE, label: NUMBER_OF_EMPLOYEES_LABEL_250_OR_MORE }
]

// ANNUAL_TURNOVER
export const ANNUAL_TURNOVER_VALUE_50_MIO_OR_LESS = 'weniger als 50 Mio. €'
export const ANNUAL_TURNOVER_LABEL_50_MIO_OR_LESS = 'weniger als 50 Mio. €'
export const ANNUAL_TURNOVER_VALUE_MORE_THAN_50_MIO = 'mehr als 50 Mio. €'
export const ANNUAL_TURNOVER_LABEL_MORE_THAN_50_MIO = 'mehr als 50 Mio. €'

export const ANNUAL_TURNOVER_OPTIONS = [
  { value: ANNUAL_TURNOVER_VALUE_50_MIO_OR_LESS, label: ANNUAL_TURNOVER_LABEL_50_MIO_OR_LESS },
  { value: ANNUAL_TURNOVER_VALUE_MORE_THAN_50_MIO, label: ANNUAL_TURNOVER_LABEL_MORE_THAN_50_MIO }
]

// ANNUAL_BALANCE_SHEET_TOTAL
export const ANNUAL_BALANCE_SHEET_TOTAL_VALUE_43_MIO_OR_LESS = 'weniger als 43 Mio. €'
export const ANNUAL_BALANCE_SHEET_TOTAL_LABEL_43_MIO_OR_LESS = 'weniger als 43 Mio. €'
export const ANNUAL_BALANCE_SHEET_TOTAL_VALUE_MORE_THAN_43_MIO = 'mehr als 43 Mio. €'
export const ANNUAL_BALANCE_SHEET_TOTAL_LABEL_MORE_THAN_43_MIO = 'mehr als 43 Mio. €'

export const ANNUAL_BALANCE_SHEET_TOTAL_OPTIONS = [
  { value: ANNUAL_BALANCE_SHEET_TOTAL_VALUE_43_MIO_OR_LESS, label: ANNUAL_BALANCE_SHEET_TOTAL_LABEL_43_MIO_OR_LESS },
  { value: ANNUAL_BALANCE_SHEET_TOTAL_VALUE_MORE_THAN_43_MIO, label: ANNUAL_BALANCE_SHEET_TOTAL_LABEL_MORE_THAN_43_MIO }
]

// PREVIOUS_FINANCIAL_PROBLEMS
export const PREVIOUS_FINANCIAL_PROBLEMS_OPTIONS = [
  { value: BOOL_VALUE_NO, label: BOOL_LABEL_YES },
  { value: BOOL_VALUE_YES, label: BOOL_LABEL_NO }
]

// PUBLIC_SECTOR_SHARE

export const PUBLIC_SECTOR_SHARE_VALUE_LESS_THAN_25_PERCENTAGE = 'keine oder weniger als 25%'
export const PUBLIC_SECTOR_SHARE_LABEL_LESS_THAN_25_PERCENTAGE = 'keine oder weniger als 25%'
export const PUBLIC_SECTOR_SHARE_VALUE_25_TO_50_PERCENTAGE  = 'mehr als 25% aber weniger als 50%'
export const PUBLIC_SECTOR_SHARE_LABEL_25_TO_50_PERCENTAGE  = 'mehr als 25% aber weniger als 50%'
export const PUBLIC_SECTOR_SHARE_VALUE_MORE_THAN_50_PERCENTAGE = 'mehr als 50%'
export const PUBLIC_SECTOR_SHARE_LABEL_MORE_THAN_50_PERCENTAGE = 'mehr als 50%'

export const PUBLIC_SECTOR_SHARE_OPTIONS = [
  { value: PUBLIC_SECTOR_SHARE_VALUE_LESS_THAN_25_PERCENTAGE , label:PUBLIC_SECTOR_SHARE_LABEL_LESS_THAN_25_PERCENTAGE },
  { value: PUBLIC_SECTOR_SHARE_VALUE_25_TO_50_PERCENTAGE, label: PUBLIC_SECTOR_SHARE_LABEL_25_TO_50_PERCENTAGE },
  { value: PUBLIC_SECTOR_SHARE_VALUE_MORE_THAN_50_PERCENTAGE, label: PUBLIC_SECTOR_SHARE_LABEL_MORE_THAN_50_PERCENTAGE }
]


// COULD_HAVE_FINANCED_ITSELF_IN_NON_EMERGENCY
export const COULD_HAVE_FINANCED_ITSELF_IN_NON_EMERGENCY_OPTIONS = [
  { value: BOOL_VALUE_YES, label: BOOL_LABEL_YES },
  { value: BOOL_VALUE_NO, label: BOOL_LABEL_NO }
]

// PRODUCT
export const PRODUCT_VALUE_LOAN = 'Darlehen'
export const PRODUCT_LABEL_LOAN = 'Darlehen'
export const PRODUCT_VALUE_OTHER = 'anderes Finanzprodukt'
export const PRODUCT_LABEL_OTHER = 'Anderes Finanzprodukt'

export const PRODUCT_OPTIONS = [
  { value: PRODUCT_VALUE_LOAN, label: PRODUCT_LABEL_LOAN },
  { value: PRODUCT_VALUE_OTHER, label: PRODUCT_LABEL_OTHER }
]

// AMOUNT_PER_COMPANY_GROUP
export const AMOUNT_PER_COMPANY_GROUP_VALUE_LESS_THAN_1_MIO = 'Unter 1 Mio. €'
export const AMOUNT_PER_COMPANY_GROUP_LABEL_LESS_THAN_1_MIO = 'Unter 1 Mio. €'
export const AMOUNT_PER_COMPANY_GROUP_VALUE_1_TO_10_MIO = '1 bis 10 Mio. €'
export const AMOUNT_PER_COMPANY_GROUP_LABEL_1_TO_10_MIO = '1 bis 10 Mio. €'
export const AMOUNT_PER_COMPANY_GROUP_VALUE_10_TO_100_MIO = '10 bis 100 Mio. €'
export const AMOUNT_PER_COMPANY_GROUP_LABEL_10_TO_100_MIO = '10 bis 100 Mio. €'
export const AMOUNT_PER_COMPANY_GROUP_VALUE_100_TO_1_BIL = '100 Mio. bis 1 Mrd. €'
export const AMOUNT_PER_COMPANY_GROUP_LABEL_100_TO_1_BIL = '100 Mio. bis 1 Mrd. €'
export const AMOUNT_PER_COMPANY_GROUP_VALUE_MORE_THAN_1_BIL = 'mehr als 1 Mrd. €'
export const AMOUNT_PER_COMPANY_GROUP_LABEL_MORE_THAN_1_BIL = 'mehr als 1 Mrd. €'

export const AMOUNT_PER_COMPANY_GROUP_1_BIL_OR_LESS_VALUES = [
  AMOUNT_PER_COMPANY_GROUP_VALUE_LESS_THAN_1_MIO,
  AMOUNT_PER_COMPANY_GROUP_VALUE_1_TO_10_MIO,
  AMOUNT_PER_COMPANY_GROUP_VALUE_10_TO_100_MIO,
  AMOUNT_PER_COMPANY_GROUP_VALUE_100_TO_1_BIL
]

export const AMOUNT_PER_COMPANY_GROUP_OPTIONS = [
  { value: AMOUNT_PER_COMPANY_GROUP_VALUE_LESS_THAN_1_MIO, label: AMOUNT_PER_COMPANY_GROUP_LABEL_LESS_THAN_1_MIO },
  { value: AMOUNT_PER_COMPANY_GROUP_VALUE_1_TO_10_MIO, label: AMOUNT_PER_COMPANY_GROUP_LABEL_1_TO_10_MIO },
  { value: AMOUNT_PER_COMPANY_GROUP_VALUE_10_TO_100_MIO, label: AMOUNT_PER_COMPANY_GROUP_LABEL_10_TO_100_MIO },
  { value: AMOUNT_PER_COMPANY_GROUP_VALUE_100_TO_1_BIL, label: AMOUNT_PER_COMPANY_GROUP_LABEL_100_TO_1_BIL },
  { value: AMOUNT_PER_COMPANY_GROUP_VALUE_MORE_THAN_1_BIL, label: AMOUNT_PER_COMPANY_GROUP_LABEL_MORE_THAN_1_BIL }
]

// AMOUNT_MAXIMUM_ONE_QUARTER_OF_2019_TURNOVER
export const AMOUNT_MAXIMUM_ONE_QUARTER_OF_2019_TURNOVER_OPTIONS = [
  { value: BOOL_VALUE_YES, label: BOOL_LABEL_YES },
  { value: BOOL_VALUE_NO, label: BOOL_LABEL_NO }
]


// AMOUNT_MAXIMUM_TWICE_OF_2019_LOAN_EXPENSES
export const AMOUNT_MAXIMUM_TWICE_OF_2019_LOAN_EXPENSES_OPTIONS = [
  { value: BOOL_VALUE_YES, label: BOOL_LABEL_YES },
  { value: BOOL_VALUE_NO, label: BOOL_LABEL_NO }
]

// AMOUNT_MATCHES_LIQUIDITY_CONSTRAINT
export const AMOUNT_MATCHES_LIQUIDITY_CONSTRAINT_OPTIONS = [
  { value: BOOL_VALUE_YES, label: BOOL_LABEL_YES },
  { value: BOOL_VALUE_NO, label: BOOL_LABEL_NO }
]

// DESIRED_TERM_OPTIONS
export const DESIRED_TERM_VALUE_6_OR_LESS = 'maximal 6 Jahre'
export const DESIRED_TERM_LABEL_6_OR_LESS = 'maximal 6 Jahre'
export const DESIRED_TERM_VALUE_6_TO_10 = 'zwischen 6-10 Jahren'
export const DESIRED_TERM_LABEL_6_TO_10 = 'zwischen 6-10 Jahren'
export const DESIRED_TERM_VALUE_10_OR_MORE = 'mehr als 10 Jahre'
export const DESIRED_TERM_LABEL_10_OR_MORE = 'mehr als 10 Jahre'

export const DESIRED_TERM_OPTIONS = [
  { value: DESIRED_TERM_VALUE_6_OR_LESS, label: DESIRED_TERM_LABEL_6_OR_LESS },
  { value: DESIRED_TERM_VALUE_6_TO_10, label: DESIRED_TERM_LABEL_6_TO_10 },
  { value: DESIRED_TERM_VALUE_10_OR_MORE, label: DESIRED_TERM_LABEL_10_OR_MORE }
]

// MAXIMUM_FIVE_YEARS_TERM
export const PROFIT_OR_DIVIDENDS_DURING_TERM_OPTIONS = [
  { value: BOOL_VALUE_YES, label: BOOL_LABEL_YES },
  { value: BOOL_VALUE_NO, label: BOOL_LABEL_NO }
]

// SUM_OF_2017_2019_WAS_A_PROFIT
export const SUM_OF_2017_2019_WAS_A_PROFIT_OPTIONS = [
  { value: BOOL_VALUE_YES, label: BOOL_LABEL_YES },
  { value: BOOL_VALUE_NO, label: BOOL_LABEL_NO }
]

// PURPOSE
export const PURPOSE_VALUE_MACHINE = 'Maschine / techn. Anlage'
export const PURPOSE_LABEL_MACHINE = 'Maschine / techn. Anlage'
export const PURPOSE_VALUE_REAL_ESTATE = 'Immobilie / Grundstück'
export const PURPOSE_LABEL_REAL_ESTATE = 'Immobilie / Grundstück'
export const PURPOSE_VALUE_VEHICLE = '(Nutz-) Fahrzeug'
export const PURPOSE_LABEL_VEHICLE = '(Nutz-) Fahrzeug'
export const PURPOSE_VALUE_OVERDRAFT_LIQUIDITY = 'Kontokorrent / Liquidität'
export const PURPOSE_LABEL_OVERDRAFT_LIQUIDITY = 'Kontokorrent / Liquidität'
export const PURPOSE_VALUE_GOODS = 'Waren / Betriebsmittel'
export const PURPOSE_LABEL_GOODS = 'Waren / Betriebsmittel'
export const PURPOSE_VALUE_RESCHEDULED_DEBT_POST_MARCH = 'Umschuldung / Ablösung von ab dem 12.03.2020 gewährten Krediten'
export const PURPOSE_LABEL_RESCHEDULED_DEBT_POST_MARCH = 'Umschuldung / Ablösung von ab dem 12.03.2020 gewährten Krediten'
export const PURPOSE_VALUE_RESCHEDULED_DEBT_PRE_MARCH = 'Umschuldung / Ablösung von bis zum 12.03.2020 gewährten Krediten'
export const PURPOSE_LABEL_RESCHEDULED_DEBT_PRE_MARCH = 'Umschuldung / Ablösung von bis zum 12.03.2020 gewährten Krediten'
export const PURPOSE_VALUE_ASSISTED_LIVING = 'Baumaßnahme für betreutes Wohnen'
export const PURPOSE_LABEL_ASSISTED_LIVING = 'Baumaßnahme für betreutes Wohnen'
export const PURPOSE_VALUE_TRUST = 'Treuhandkonstruktion'
export const PURPOSE_LABEL_TRUST = 'Treuhandkonstruktion'
export const PURPOSE_VALUE_SELF_DEALINGS = 'In-Sich-Geschäft, z.B. Erwerb eigener Unternehmensanteile'
export const PURPOSE_LABEL_SELF_DEALINGS = 'In-Sich-Geschäft, z.B. Erwerb eigener Unternehmensanteile'
export const PURPOSE_VALUE_FOLLOW_UP = 'Nachfinanzierung, Anschlussfinanzierung, Prolongation'
export const PURPOSE_LABEL_FOLLOW_UP = 'Nachfinanzierung, Anschlussfinanzierung, Prolongation'

export const PURPOSE_OPTIONS = [
  { value: PURPOSE_VALUE_MACHINE, label: PURPOSE_LABEL_MACHINE },
  { value: PURPOSE_VALUE_REAL_ESTATE, label: PURPOSE_LABEL_REAL_ESTATE },
  { value: PURPOSE_VALUE_VEHICLE, label: PURPOSE_LABEL_VEHICLE },
  { value: PURPOSE_VALUE_OVERDRAFT_LIQUIDITY, label: PURPOSE_LABEL_OVERDRAFT_LIQUIDITY },
  { value: PURPOSE_VALUE_GOODS, label: PURPOSE_LABEL_GOODS },
  { value: PURPOSE_VALUE_RESCHEDULED_DEBT_POST_MARCH, label: PURPOSE_LABEL_RESCHEDULED_DEBT_POST_MARCH },
  { value: PURPOSE_VALUE_RESCHEDULED_DEBT_PRE_MARCH, label: PURPOSE_LABEL_RESCHEDULED_DEBT_PRE_MARCH },
  { value: PURPOSE_VALUE_ASSISTED_LIVING, label: PURPOSE_LABEL_ASSISTED_LIVING },
  { value: PURPOSE_VALUE_TRUST, label: PURPOSE_LABEL_TRUST },
  { value: PURPOSE_VALUE_SELF_DEALINGS, label: PURPOSE_LABEL_SELF_DEALINGS },
  { value: PURPOSE_VALUE_FOLLOW_UP, label: PURPOSE_LABEL_FOLLOW_UP }
]

export const PURPOSE_MAPPING = {
  [PURPOSE_VALUE_MACHINE]: 'machine',
  [PURPOSE_VALUE_GOODS]: 'goods',
  [PURPOSE_VALUE_REAL_ESTATE]: 'real_estate',
  [PURPOSE_VALUE_RESCHEDULED_DEBT_PRE_MARCH]: 'debt_rescheduling',
  [PURPOSE_VALUE_RESCHEDULED_DEBT_POST_MARCH]: 'debt_rescheduling',
  [PURPOSE_VALUE_VEHICLE]: 'vehicle',
  [PURPOSE_VALUE_OVERDRAFT_LIQUIDITY]: 'liquidity'
}
